import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=0b073472&scoped=true&"
import script from "./informationDetail.vue?vue&type=script&lang=js&"
export * from "./informationDetail.vue?vue&type=script&lang=js&"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=0b073472&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b073472",
  null
  
)

export default component.exports